module.exports = __webpack_public_path__ + "img/bicycle-1x.dbaa6d7c.png";